export function resolveView({ hostname, pathname }) {
  if (hostname === "dashboard.weizhi.me") return "dashboard";
  if (hostname === "photos.weizhi.me") return "photos";

  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
  if (isLocal && pathname.startsWith("/dashboard")) return "dashboard";

  if (pathname.startsWith("/photos")) return "photos";
  return "site";
}
